<template>
  <editable-box
    :mode="mode"
    :includeBtns="['drag', 'setup', 'confirm', 'edit', 'delete', 'add']"
    @onSetup="hanldeSetup"
    @onAdd="handleAdd"
    @onDelete="handleDelete"
    @onConfirm="hanldeConfirm"
  >
    <template slot-scope="scope">
      <a :href="data.jumpHref || null" target="_blank">
        <div class="charactor-box" :class="{ 'is-edit': mode === 'edit' }">
          <div class="avatar">
            <img v-if="data.avatar" :src="data.avatar" />
            <upload-image v-else-if="mode === 'edit'" @onImageUploaded="handelAvatarUploaded"></upload-image>
            <div class="edit-btns" v-if="data.avatar && mode === 'edit'">
              <button class="btn edit-btn">
                <upload-image type="edit" :data="data.avatar" @onImageUploaded="handelAvatarUploaded">
                  <i class="wiki-icon wiki-editable-edit"></i>
                </upload-image>
              </button>
            </div>
          </div>
          <div class="name">
            <base-input
              v-if="scope.isEdit"
              v-model="inputNameValue"
              @onBlur="hanldeConfirm"
              @onSubmit="hanldeConfirm"
            ></base-input>
            <span v-else>
              {{ inputNameValue || "名称" }}
            </span>
          </div>
        </div>
        <!-- 设置 -->
        <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="data" @onChange="handleItemSetup"></setup-panel>
      </a>
    </template>
  </editable-box>
</template>

<script>
// components
import UploadImage from "../../../../components/UploadImage";
import EditableBox from "../../../../components/EditableBox/index.jsx";
import BaseInput from "../../../../components/BaseInput";
import SetupPanel from "./SetupPanel";

export default {
  name: "charactor-box",
  components: {
    UploadImage,
    BaseInput,
    EditableBox,
    SetupPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      inputNameValue: this.data.name || ""
    };
  },

  mounted() {},

  methods: {
    hanldeSetup() {
      this.$refs.setupPanel.open();
    },
    handleItemSetup(data) {
      this.$emit("onChange", data);
    },
    handelAvatarUploaded(imgList) {
      const data = this.data;
      data.avatar = imgList[0];
      this.$emit("onChange", data);
    },
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    hanldeConfirm() {
      const data = this.data;
      data.name = this.inputNameValue;
      this.$emit("onChange", data);
    }
  }
};
</script>

<style lang="less" scoped>
.charactor-box {
  width: 104px;
  height: 146px;
  background-image: url("../../../../../../../../assets/images/charactor-box-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 8px 10px 8px 10px;
  border-radius: 2px;
  &.is-edit {
    .avatar {
      &:hover {
        background-color: #c7ccd5;
        outline: #c7ccd5;
        outline-style: solid;
        outline-width: 3px;
        cursor: pointer;
        .edit-btns {
          display: inline-flex;
        }
      }
    }
  }
  .avatar {
    position: relative;
    width: 84px;
    height: 84px;
    border: 1px solid #fff;
    border-radius: 4px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: cover;
    }
    .edit-btns {
      display: none;
      position: absolute;
      height: 20px;
      right: -20px;
      top: 0px;
      .btn {
        width: 20px;
        height: 20px;
        color: #ffffff;
        border-radius: 4px;
        margin-left: 3px;
        border: none;
        vertical-align: middle;
        line-height: 20px;
        text-align: center;
        overflow: hidden;
        &:hover {
          opacity: 0.9;
        }
        .wiki-icon {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .name {
    width: 100%;
    height: 23px;
    margin-top: 12px;
    background: #565d7a;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    line-height: 23px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
